import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const HeaderStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      marginBottom: "16px",
      height: "auto",
      borderBottom: "1px solid #F5F3EF",
      paddingBottom: "16px",
    },

    heading: {
      fontFamily: "Roobert, sans-serif",
      fontWeight: 500,
      fontSize: "16px",
      lineHeight: "20px",
      color: "#002035",
      marginLeft: "0",
    },
  }),
);
